const AUTH_HTML_URL = window.location.origin + '/static/auth.html';
// https://learninggames.northwestern.edu/geo/auth.html
const LOGIN_URL = "https://prd-nusso.it.northwestern.edu/nusso?goto=" + window.location.href;
const LOGOUT_URL = "https://prd-nusso.it.northwestern.edu/nusso/XUI#logout&goto=" + window.location.href;
const SSO_COOKIE_NAME = "nusso";
const JWT_COOKIE_NAME = 'roomReadyJWT_v2-1-0';
const JWT_COOKIE_DOMAIN = '.roomready.northwestern.edu';

//@TODO: move this to the instantiation of the class
var VALID_ORIGINS = [ window.location.origin ];

class VueOpenAMAuth {
    constructor(Vue, options = {}) {
        var _this = this;
        this.options = options;
        this.options.Vue = Vue;
        this.watch = new this.options.Vue({
            data() {
                return {
                    data: null,
                    loaded: false,
                    redirect: null,
                    processing: false,
                    authenticated: false,
                    authWorkflowComplete: false
                };
            },
            watch: {
                loaded(val) {
                    if (val === true && _this.options.readyCallback) {
                        _this.options.readyCallback();
                    }
                }
            }
        });
        this.login_window = null;
        this.valid_origins = options.valid_origins || VALID_ORIGINS;
        window.addEventListener("message", this.receiveMessage.bind(this), false);
    }

    isLoaded() {
      var _this = this;
      return new Promise((resolve) => {
        _this.ready();
        var authLoadedTimer = setInterval(function () {
          if (_this.watch.loaded) {
            clearInterval(authLoadedTimer);
            resolve();
          }
        }, 100);
      })
    }

    authWorkflowComplete() {
      var _this = this;
      return new Promise((resolve) => {
        this.watch.authWorkflowComplete = false;
        var authWorkflowTimer = setInterval(function () {
          if (_this.watch.authWorkflowComplete) {
            clearInterval(authWorkflowTimer);
            resolve(_this.watch.authenticated);
          }
        }, 100);
      })
    }

    userLoginSuccessful() {
      var _this = this;
      return new Promise((resolve) => {
        var userLoginSuccessfulTimer = setInterval(function () {
          if (_this.watch.authenticated) {
            clearInterval(userLoginSuccessfulTimer);
            resolve();
          }
        }, 100);
      })
    }

    validateOrigin(origin) {
        return this.valid_origins.indexOf(origin) >= 0;
    }

    receiveMessage(e) {
        if (e.data && e.data.length && e.data.match(/^pym/)) {
            console.log("ignoring message from pym.js");
            return;
        }

        // Login events return and empty event object. We need to return here for other
        // window message events, since this event handler is used by other components
        // (react, react dev tools, webpack hot reload)
        if (!this.validateOrigin(e.origin)) {
            return;
        }

        if (this.login_window){
            this.login_window.close();
        }
        this.authenticate();
    }

    authenticate() {
        this.watch.processing = true;
        this.getAttributes((err, userdata) => {
            if (err) {
                this.watch.authenticated = false;
                this.user(null);
                this.watch.processing = false;
            } else {
                this.watch.authenticated = true;
                this.user(userdata);
                this.watch.processing = false;
            }
            this.watch.authWorkflowComplete = true;
        });
        this.watch.loaded = true;
    }

    getAttributes(callback) {
        var KEY = "subjectid";
        var url = this.options.authUrl;

        var opts = {
          credentials: 'include'
        };
        fetch(url, opts).then(res => res.json()).then(attrs => {
            if (Object.keys(attrs).length === 0 || typeof(attrs.attributes) !== 'object' || Object.keys(attrs.attributes).length === 0) {
                callback('not authenticated');
                console.log('not authenticated');
                return;
            }

            callback(null, attrs.attributes);
        }).catch(err => {
            callback(err);
        });
    }

    parseAttrs(attrs) {
        var rows = attrs.split("\n");
        var key = null;
        var old_key = null;
        var value = [];

        var data = {};

        var cleanKey = function (key) {
            return key.replace("userdetails.attribute.", "", key);
        }

        for (var i = 0; i < rows.length; i++) {
            // key or value?
            var pair = rows[i].split("=");
            var left = pair.shift();
            var right = pair.join("=");

            if (left.match(/name$/)) {
                key = cleanKey(right);
                data[key] = [];
                continue;
            } else if (left.match(/value$/)) {
                data[key].push(right);
            }
        }
        // convert arrays with single item to strings.
        Object.keys(data).forEach(function (key) {
            if (data[key].length === 1) {
                data[key] = data[key][0];
            }
        });

        return data;
    }

    ready() {
        this.authenticate();
    }

    redirect() {
        return this.watch.redirect;
    }

    user(data) {
        if (data) {
            this.watch.data = data;
        }
        return this.watch.data || {};
    }

    login() {
        window.location.href = LOGIN_URL;
    }

    logout() {
        console.log("logout");
        var _this = this;
        this.watch.authWorkflowComplete = false;

        fetch(this.options.logoutUrl, { credentials: 'include' }).then(() => {
          window.location.href = LOGOUT_URL;
        });
    }
}

export default {
    install(Vue, opts) {
        var auth = new VueOpenAMAuth(Vue, opts);
        Vue.$auth = auth;
        Vue.prototype.$auth = auth;
    }
}



// WEBPACK FOOTER //
// ./src/services/vue-openam.js